<script lang="ts">
    import { mdiCartOutline, mdiEmail, mdiFileDocument, mdiPencil, mdiPlus } from "@mdi/js"
    import Icon from "../../../widgets/Icon.svelte"
    import { tooltip } from "../../../../helper"
    import { _ } from "svelte-i18n"

    export let item: any
    const iconsByType: {
        [x: string]: any
        default?: string
        created?: string
        edited?: string
        added?: string
        email?: string
        ordered?: string
    } = {
        default: mdiPencil,
        created: mdiFileDocument,
        edited: mdiPencil,
        added: mdiPlus,
        email: mdiEmail,
        ordered: mdiCartOutline,
    }

    function getItemActioni18n(action: string) {
        if (action == "Erstellung der Auftragsbestätigung")
            return $_("components.operationProtocol.creationOrderConfirmation")
        else if (action == "Erstellung des Angebots") return $_("components.operationProtocol.creationOffer")
        else if (action == "Bearbeitung der Auftragsbestätigung")
            return $_("components.operationProtocol.processingOrderConfirmation")
        else if (action == "Bearbeitung des Angebots") return $_("components.operationProtocol.processingOffer")
    }
</script>

<div
    class="layout layout-gap-sm align-items-center"
    use:tooltip="{{
        content: getItemActioni18n(item.action),
    }}"
>
    <div style="min-width: fit-content">
        <Icon path="{iconsByType[item.actionType ? item.actionType : 'default']}" size="24px" />
    </div>
    {getItemActioni18n(item.action)}
</div>
